import { makeStyles, Theme, createStyles } from "@material-ui/core";

export const stylesReCaptcha: () => Record<string, string> = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            margin: "auto"
        }
    }));